import { Link } from "react-router-dom";
import { CheckCircle, Clock, Monitor, ArrowRight, FileText, Users, Award, Tag } from "lucide-react";

const C = {
  bg: "#FAFAF8", white: "#FFFFFF", navy: "#1B2A4A",
  gold: "#C9A452", goldLight: "rgba(201,164,82,0.12)", goldBorder: "rgba(201,164,82,0.3)",
  text: "#111827", muted: "#6B7280", light: "#9CA3AF", border: "#E8E3D8", section: "#F5F2EC",
};

const PROMO_DATE = "30 septembre 2026";

const FORMATIONS = [
  {
    id: 1, tag: "Formation VTC", title: "Formation VTC",
    subtitle: "Chauffeur de Voiture de Transport avec Chauffeur",
    duration: "7 modules — Cours du soir, 2 semaines", mode: "Distanciel accompagné",
    prixBarre: "1 490 €", prix: "699 €", highlight: false,
    objectif: "Obtenir la carte professionnelle VTC et exercer légalement. Programme complet avec coaching personnalisé.",
    public: "Toute personne souhaitant devenir chauffeur VTC. Permis B requis.",
    certification: "Préparation à l'examen CMA IDF",
    inclus: ["Coaching personnalisé inclus", "Assistance tout au long de la formation", "Préparation intensive à l'examen CMA"],
    modules: ["Réglementation VTC et transport de personnes T3P", "Géographie et territoire IDF", "Tarification et facturation", "Relation client et accueil professionnel", "Sécurité routière et comportement", "Gestion administrative et obligations", "Préparation intensive à l'examen CMA"],
    stripeLink: "https://buy.stripe.com/00w3cv6776rE4gn0UudZ605",
  },
  {
    id: 2, tag: "Passerelle — Le plus demandé", title: "Passerelle VTC → Taxi",
    subtitle: "Formation accélérée pour titulaires de la carte VTC",
    duration: "7 modules — Cours du soir, 2 semaines", mode: "Distanciel accompagné",
    prixBarre: "990 €", prix: "499 €", highlight: true,
    objectif: "Compléter les compétences VTC pour accéder au statut taxi. Ciblé et efficace.",
    public: "Titulaires d'une carte professionnelle VTC en cours de validité.",
    certification: "Préparation à l'examen CMA IDF",
    inclus: ["Coaching personnalisé inclus", "Assistance tout au long de la formation", "Paiement sécurisé en ligne"],
    modules: ["Réglementation Taxi vs VTC", "Tarification taxi et taximètre", "Connaissance du territoire — zones IDF", "Réglementation T3P complète", "Relation client spécifique taxi", "Déontologie et responsabilités", "Préparation intensive à l'examen CMA"],
    stripeLink: "https://buy.stripe.com/00w3cv6776rE4gn0UudZ605",
  },
  {
    id: 3, tag: "Formation Taxi", title: "Formation Taxi",
    subtitle: "Licence taxi — Certificat de Capacité Professionnelle (CCPCT)",
    duration: "7 modules — Cours du soir, 2 semaines", mode: "Distanciel accompagné",
    prixBarre: "1 690 €", prix: "799 €", highlight: false,
    objectif: "Obtenir la licence taxi et exercer comme chauffeur professionnel en IDF.",
    public: "Toute personne souhaitant devenir chauffeur taxi. Permis B depuis 3 ans minimum.",
    certification: "Préparation à l'examen CMA IDF",
    inclus: ["Coaching personnalisé inclus", "Assistance tout au long de la formation", "Préparation intensive à l'examen CMA"],
    modules: ["Réglementation taxi et T3P", "Géographie Paris et IDF", "Tarification, compteur et matériel", "Relation client et accueil PMR", "Sécurité routière et premiers secours", "Déontologie professionnelle", "Préparation intensive à l'examen CMA"],
    stripeLink: "https://buy.stripe.com/00w3cv6776rE4gn0UudZ605",
  },
];

function GoldDivider() {
  return <div style={{ width: 48, height: 3, background: `linear-gradient(90deg, ${C.gold}, transparent)`, borderRadius: 2, margin: "14px 0 20px" }} />;
}

export default function Formations() {
  return (
    <div style={{ background: C.bg }}>
      {/* Header */}
      <div style={{ background: C.navy, padding: "64px 24px 56px", textAlign: "center" }}>
        <div style={{ display: "inline-block", padding: "4px 14px", borderRadius: 20, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: C.gold, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 16 }}>
          3 formations disponibles
        </div>
        <h1 style={{ fontSize: "clamp(28px, 5vw, 48px)", fontWeight: 700, color: "#fff", marginBottom: 14, fontFamily: "'Playfair Display', serif" }}>
          Formations Taxi & VTC
        </h1>
        <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 15, maxWidth: 520, margin: "0 auto 20px" }}>
          Cours du soir en distanciel accompagné · 7 modules · 2 semaines · Coaching inclus pour réussir l'examen CMA
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 12, justifyContent: "center" }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 18px", borderRadius: 10, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: C.gold, fontWeight: 700, fontSize: 13 }}>
            <Tag size={14} /> Prix en promotion jusqu'au {PROMO_DATE}
          </div>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "9px 18px", borderRadius: 10, background: "rgba(220,38,38,0.12)", border: "1px solid rgba(220,38,38,0.25)", color: "#fca5a5", fontWeight: 600, fontSize: 13 }}>
            🗓️ Prochain examen CMA : 30 juin 2026 — Clôture : 22 mai 2026
          </div>
        </div>
      </div>

      {/* Formations */}
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "56px 24px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 28 }}>
          {FORMATIONS.map((f) => (
            <div key={f.id} style={{ borderRadius: 20, border: `1px solid ${f.highlight ? C.gold : C.border}`, background: C.white, overflow: "hidden", boxShadow: f.highlight ? `0 8px 32px ${C.goldLight}` : "0 2px 16px rgba(27,42,74,0.05)" }}>
              {f.highlight && (
                <div style={{ background: C.gold, color: C.navy, textAlign: "center", fontSize: 12, fontWeight: 800, padding: "8px 0", letterSpacing: "0.08em" }}>
                  ⭐ FORMATION LA PLUS DEMANDÉE
                </div>
              )}
              {/* Top */}
              <div style={{ padding: "28px 32px", borderBottom: `1px solid ${C.border}`, display: "flex", flexWrap: "wrap", alignItems: "flex-start", gap: 20, background: f.highlight ? "#FFFDF6" : C.white }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "inline-block", padding: "3px 11px", borderRadius: 20, marginBottom: 8, fontSize: 11, fontWeight: 700, textTransform: "uppercase" as const, letterSpacing: "0.1em", background: f.highlight ? C.goldLight : C.section, color: f.highlight ? "#92700a" : C.muted }}>{f.tag}</div>
                  <h2 style={{ fontSize: "clamp(20px, 3vw, 26px)", fontWeight: 700, color: C.navy, margin: "0 0 4px", fontFamily: "'Playfair Display', serif" }}>{f.title}</h2>
                  <div style={{ color: C.gold, fontSize: 14, fontWeight: 600, marginBottom: 10 }}>{f.subtitle}</div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 16 }}>
                    <span style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: C.muted }}><Clock size={13} color={C.navy} /> {f.duration}</span>
                    <span style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: C.muted }}><Monitor size={13} color={C.navy} /> {f.mode}</span>
                  </div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 13, color: C.light, textDecoration: "line-through", marginBottom: 2 }}>Tarif moyen : {f.prixBarre}</div>
                  <div style={{ fontSize: "clamp(30px, 4vw, 42px)", fontWeight: 800, color: C.navy, lineHeight: 1, fontFamily: "'Playfair Display', serif" }}>{f.prix}</div>
                  <div style={{ display: "inline-flex", alignItems: "center", gap: 4, marginTop: 6, padding: "3px 10px", borderRadius: 20, background: C.goldLight, border: `1px solid ${C.goldBorder}`, color: "#92700a", fontSize: 11, fontWeight: 700 }}>
                    <Tag size={9} /> Promo jusqu'au {PROMO_DATE}
                  </div>
                </div>
              </div>

              {/* Body */}
              <div style={{ padding: "28px 32px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 36 }}>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: C.navy, textTransform: "uppercase" as const, letterSpacing: "0.1em", marginBottom: 14, display: "flex", alignItems: "center", gap: 7 }}>
                    <FileText size={13} /> Programme — 7 modules
                  </div>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 9 }}>
                    {f.modules.map((m) => (
                      <li key={m} style={{ display: "flex", alignItems: "flex-start", gap: 9, fontSize: 13, color: C.text }}>
                        <CheckCircle size={14} color={C.gold} style={{ flexShrink: 0, marginTop: 1 }} /> {m}
                      </li>
                    ))}
                  </ul>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: C.navy, textTransform: "uppercase" as const, letterSpacing: "0.1em", marginBottom: 10, display: "flex", alignItems: "center", gap: 7 }}>
                      <Award size={13} /> Inclus dans la formation
                    </div>
                    {f.inclus.map((inc) => (
                      <div key={inc} style={{ display: "flex", alignItems: "flex-start", gap: 8, fontSize: 13, color: C.text, marginBottom: 7 }}>
                        <CheckCircle size={14} color="#16a34a" style={{ flexShrink: 0, marginTop: 1 }} /> {inc}
                      </div>
                    ))}
                    <div style={{ marginTop: 10, padding: "8px 12px", borderRadius: 8, background: C.goldLight, border: `1px solid ${C.goldBorder}`, fontSize: 12, color: "#92700a" }}>
                      ⚠️ + Frais d'examen CMA à prévoir en sus
                    </div>
                  </div>
                  {/* Coaching */}
                  <div style={{ padding: "14px 16px", borderRadius: 12, background: C.section, border: `1px solid ${C.border}` }}>
                    <div style={{ fontWeight: 700, fontSize: 13, color: C.navy, marginBottom: 6 }}>🎯 Coaching pour réussir l'examen</div>
                    <div style={{ fontSize: 12, color: C.muted, lineHeight: 1.6 }}>
                      Mises en situation, QCM d'entraînement, suivi individuel par Sonia jusqu'à la réussite de votre examen.
                    </div>
                  </div>
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 700, color: C.navy, textTransform: "uppercase" as const, letterSpacing: "0.1em", marginBottom: 8, display: "flex", alignItems: "center", gap: 7 }}>
                      <Users size={13} /> Public visé
                    </div>
                    <p style={{ color: C.muted, fontSize: 13, lineHeight: 1.7, margin: 0 }}>{f.public}</p>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: "auto" }}>
                    <Link to="/inscription" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "13px 20px", borderRadius: 10, background: f.highlight ? C.gold : C.navy, color: f.highlight ? C.navy : "#fff", border: "none", fontWeight: 700, fontSize: 14, textDecoration: "none", boxShadow: `0 6px 20px rgba(27,42,74,0.16)` }}>
                      S'inscrire à cette formation <ArrowRight size={15} />
                    </Link>
                    <a href="https://wa.me/33749124282" target="_blank" rel="noreferrer" style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, padding: "11px 20px", borderRadius: 10, background: "rgba(22,163,74,0.08)", border: "1px solid rgba(22,163,74,0.25)", color: "#15803d", fontWeight: 600, fontSize: 13, textDecoration: "none" }}>
                      💬 Inscription via WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* Financement */}
        <div style={{ marginTop: 44, borderRadius: 16, padding: 32, textAlign: "center", background: C.navy }}>
          <h3 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 10 }}>Financement de votre formation</h3>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, maxWidth: 480, margin: "0 auto 20px" }}>
            Paiement direct sécurisé en ligne — Stripe · CB
          </p>
          <Link to="/contact" style={{ display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 24px", borderRadius: 10, background: C.gold, color: C.navy, fontWeight: 700, fontSize: 14, textDecoration: "none" }}>
            Contacter un conseiller →
          </Link>
        </div>
      </div>
    </div>
  );
}
